<template>
  <Modal v-model="model"  sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable class="manual_out_textarea">
    <div class="manual_call_left">
      <div class="font_style_set"><span class="span_must">*</span>联系人:</div>
      <Input  v-model="listname" class="config_content" placeholder="请输入联系人" clearable style="width: 250px"/>
    </div>
    <div class="manual_call_right">
      <div class="font_style_set"><span class="span_must">*</span>联系号码:</div>
      <Input  v-model="listnumber" class="config_content" placeholder="请输入联系号码" clearable style="width: 250px"/>
    </div>
    <div class="definition_text_area">
      <div class="font_style_set">备注:</div>
      <Input  v-model="listnote" placeholder="请输入备注" clearable  style="width:83%" type="textarea" />
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "AddmailPop",
      mixins:[publicFunClass],
      props: {
        showaddmail:Boolean,
        maillistId:String,
        maillisttel:String,
        maillistname:String,
        maillistnote:String,
      },
      data(){
        return {
          model:false,

          listname:'',
          listnumber:'',
          listnote:'',

          title:'',
          journalType:'',
          menuId:'',

          managelist:[],
        }
      },
      methods:{
        cancel:function(){
          this.$emit("closeaddmailPop",false);
        },
        save:function(){
          let that=this;
          if(!this.listnumber){
            that.$Modal.info({
              title:'提示',
              content:"联系号码不能为空"
            });
            return false;
          }
          if(!this.listname){
            that.$Modal.info({
              title:'提示',
             content:"联系人不能为空"
            });
            return false;
          }
          let param= {
            journalType:this.journalType,
            menuId:this.menuId,
            telephone:this.listnumber,//号码
            userName:this.listname,
            note:this.listnote,
            id:this.maillistId,
          }
          this.$http.post("externalAddressBook/doSave.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("操作成功");
            that.$emit("closeaddmailPop",true);
          });
        },
        initSearch:function () {
          if(this.maillistId){
            this.listnumber=this.maillisttel;
            this.listname=this.maillistname;
            this.listnote=this.maillistnote;
          }else{
            this.listnumber="";
            this.listname="";
            this.listnote="";
          }
        },
      },
      watch:{
        showaddmail:function () {
          this.model=this.showaddmail;
          if(this.showaddmail){
            if(!this.maillistId){//添加
              this.title='添加联系人';
              this.journalType="用户管理=>通讯录=>添加";
              this.menuId="9_5-1";
            }else{//编辑
              this.title='编辑联系人';
              this.journalType="用户管理=>通讯录=>编辑";
              this.menuId="9_5-5";
            }
            this.initSearch();
          }
        }
      }
    }
</script>

<style lang="less">
.manual_out_textarea{
  display: flex;
  align-items: center;
  justify-content: center;
  .span_must{
    color: #ed4014;
    line-height: 30px;
    padding-right: 2px;
  }
  .ivu-modal{
    top: 120px;
    .ivu-modal-content{
      width: 800px !important;
    }
  }
  .ivu-modal-content{
    width: 800px;
    height: 220px;
    .ivu-select-selection{
      border-radius: 1px;
      height: 30px;
    }
    .ivu-input{
      border-radius: 1px;
      height: 30px;
    }
    .ivu-modal-body{
      width: 800px;
    }
  }
  .definition_text_area{
    margin-top: 10px;
    width: 100%;
    float: left;
    .ivu-input{
      border-radius: 1px;
      height: 60px;
      line-height: 20px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    textarea{
      resize: none;
    }
  }
  .font_style_set{
    width: 100px;
    float: left;
    text-align: right;
    margin-right: 10px;
  }
  .config_content{
    float: left;
    margin-top: 7px;
  }
  .manual_call_left{
    width: 50%;
    float: left;
    height: 44px;
    line-height: 44px;
  }
  .manual_call_right{
    width: 50%;
    float: right;
    height: 44px;
    line-height: 44px;
  }
  .el-date-editor{
    border-radius: 1px;
    height: 30px;
    line-height: 30px;
    .el-range-input{
      font-size: 12px;
      height: 30px;
    }
    .el-range-separator{
      height: 30px;
      line-height: 30px;
    }
    .el-input__inner{
      height: 30px;
      line-height: 30px;
      border-radius: 1px;
    }
    .el-input__icon{
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userManagement/AddmailPop.vue